import LocalStorage from "utils/localstorage.util";
import { authActions } from "redux/slices/auth";

/** Partner JWT / getprices user objects use `phone_number`; forms expect `phone`. */
export function normalizePartnerUser(raw: unknown) {
  if (!raw || typeof raw !== "object") return null;

  const record = raw as Record<string, unknown>;
  const phoneRaw = `${record.phone || record.phone_number || ""}`.trim();
  const digits = phoneRaw.replace(/\D/g, "");

  return {
    ...record,
    user_id: record.user_id || record.external_user_id,
    external_user_id: record.external_user_id || record.user_id,
    first_name: record.first_name || "",
    last_name: record.last_name || "",
    email: record.email || "",
    phone: digits || phoneRaw.replace(/^\+/, ""),
    phone_number:
      record.phone_number ||
      (phoneRaw.startsWith("+") ? phoneRaw : digits ? `+${digits}` : ""),
    title: record.title || "Mr.",
  };
}

export function getStoredPartnerUser() {
  return normalizePartnerUser(LocalStorage.getItem("user"));
}

export function persistPartnerUser(
  raw: unknown,
  dispatch?: (action: ReturnType<typeof authActions.setUser>) => void
) {
  const normalized = normalizePartnerUser(raw);
  if (!normalized) return null;

  LocalStorage.setItem("user", normalized);
  dispatch?.(authActions.setUser(normalized));
  return normalized;
}

/** Phone value for redux-form PhoneInput (`{ value: digits }`). */
/** MC requires email — partner checkout often omits it; mirror user-next fallback. */
export function resolvePartnerPassengerEmail(
  passengerForm?: { email?: string } | null,
  storedUser?: Record<string, unknown> | null
) {
  const direct = `${passengerForm?.email || storedUser?.email || ""}`.trim();
  if (direct) return direct;

  const userId =
    `${storedUser?.user_id || storedUser?.external_user_id || ""}`.trim();
  if (userId) return `yelo-app-${userId}@partner.yeloplus.local`;

  return "";
}

export function partnerUserPhoneFieldValue(user: Record<string, unknown> | null) {
  if (!user) return null;
  const phone = `${user.phone || user.phone_number || ""}`.trim();
  if (!phone) return null;
  const digits = phone.replace(/\D/g, "");
  return { value: digits || phone.replace(/^\+/, "") };
}
